import { useMemo } from 'react';
import MuiAlert, { AlertProps, AlertColor as AlertSeverity } from '@mui/material/Alert';
import FilledCheckCircleIcon from '@mui/icons-material/CheckCircle';
import FilledWarningIcon from '@/components/Icons/FilledWarningIcon';
import FilledAlertIcon from '@/components/Icons/FilledAlertIcon';
import FilledInfoIcon from '@/components/Icons/FilledInfoIcon';

export { MuiAlert, type AlertProps, type AlertSeverity };

/**
 * @summary Show any useful information about process in the application.
 * @param {AlertProps} props
 */
const Alert = (props: AlertProps) => {
  const { variant } = props;

  const iconMapping = useMemo(() => {
    return {
      success: <FilledCheckCircleIcon />,
      error: props?.variant === 'text' ? <FilledAlertIcon /> : <FilledWarningIcon />,
      warning: <FilledAlertIcon />,
      info: <FilledInfoIcon />,
    };
  }, [FilledCheckCircleIcon, FilledAlertIcon, FilledWarningIcon, FilledInfoIcon, variant]);

  return (
    <MuiAlert
      {...props}
      iconMapping={iconMapping}
    />
  );
};

export default Alert;
